var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center my-12 px-4 w-full"},[_vm._t("default"),(_vm.hasCustomNavigation)?_vm._t("navigation"):_c('step-navigation',{attrs:{"wizard":_vm.wizard,"navigation":_vm.navigation}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }